import axios from 'axios';

const authHeaders = () => ({
    withCredentials: true,
});

export const fetchStockSetupStatus = async () => {
    const response = await axios.get(process.env.REACT_APP_STOCK_SETUP_STATUS_ROUTE, authHeaders());
    return response.data;
};

export const fetchPublicStockSetupStatus = async (shopBranchId) => {
    const response = await axios.get(process.env.REACT_APP_STOCK_SETUP_PUBLIC_STATUS_ROUTE, {
        params: { shopBranchId },
    });
    return response.data;
};

export const fetchZeroStockProducts = async () => {
    const response = await axios.get(process.env.REACT_APP_STOCK_SETUP_ZERO_STOCK_ROUTE, authHeaders());
    return response.data || [];
};

export const fetchAllPendingStockProducts = async () => {
    const response = await axios.get(process.env.REACT_APP_STOCK_SETUP_PENDING_ALL_ROUTE, authHeaders());
    return response.data || [];
};

export const fetchPendingStockProducts = async (page = 1, size = 20) => {
    const response = await axios.get(process.env.REACT_APP_STOCK_SETUP_PENDING_ROUTE, {
        ...authHeaders(),
        params: { page, size },
    });
    return response.data;
};

export const bootstrapStockSetup = async (payload) => {
    const response = await axios.post(process.env.REACT_APP_STOCK_SETUP_BOOTSTRAP_ROUTE, payload, authHeaders());
    return response.data;
};

export const completeStockSetup = async () => {
    const response = await axios.post(process.env.REACT_APP_STOCK_SETUP_COMPLETE_ROUTE, {}, authHeaders());
    return response.data;
};
